import { render } from "./TableBottom.vue?vue&type=template&id=7cafb1bc&scoped=true"
import script from "./TableBottom.vue?vue&type=script&lang=js"
export * from "./TableBottom.vue?vue&type=script&lang=js"

import "./TableBottom.vue?vue&type=style&index=0&id=7cafb1bc&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cafb1bc"]])

export default __exports__